import { Component, OnInit } from '@angular/core';
import { SidenavService } from '../../services/sidenav.service';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../../store/state.model';
import { MatButton } from '@angular/material/button';
import { NgIf, NgFor, KeyValuePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-features',
    templateUrl: './app-features.component.html',
    styleUrls: ['./app-features.component.scss'],
    imports: [MatButton, NgIf, NgFor, TranslatePipe, KeyValuePipe]
})
export class AppFeaturesComponent implements OnInit {
  /**
  *@arg Property to store all the features of the vehicle
  **/
  public selectedVehicleFeatures: Object;
  /**
  *@arg Property to store the features of the vehicle which are shown
  **/
  public showFeatures: any[];
  /**
  *@arg Property to store the value whether the selected vehicle has features or not
  **/
  public isVehicleFeaturesEmpty: boolean;
  /**
  *@arg Property to store the value of the selected car brand name
  **/
  public vehicleBrand: string;
  /**
  *@arg Property to store the selected vehicle details
  **/
  public selectedVehicle: any;


  constructor(
    private sidenav: SidenavService,
    private reduxState: NgRedux<AppState>,
  ) {
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations which subscribes to route
   */
  ngOnInit() {
    this.selectedVehicle = this.reduxState.getState().selectedVehicle;
    const rawFeatures = this.selectedVehicle.vehicle['features'];
    const selectedVehicleFeatures = Object.assign({}, rawFeatures);
    const brand = this.selectedVehicle.vehicle['brand'] || this.selectedVehicle.vehicle['brandCode'] || '';
    this.vehicleBrand = brand[0] && brand[0].toLowerCase() === 'l' ? 'Lexus' : brand[0] && brand[0].toLowerCase() === 's' ? 'Subaru' : 'Toyota';
    if (Object.keys(selectedVehicleFeatures).length === 0) {
      this.isVehicleFeaturesEmpty = true;
    }
    const hideFeatures = ['achPayment', 'autoDrive', 'cerence', 'connectedCard', 'connectedSupport', 'criticalAlert', 'dynamicNavi', 'importantMessage', 'marketingCard',
      'masterConsentEditable', 'ownersManual', 'paidProduct', 'ssaDownload', 'telemetry', 'xcapp', 'huGenerations', 'safetyRecall', 'marketingConsent', 'myDestination',
      'parkedVehicleLocator', 'parkingNotes', 'remoteDtc', 'vaChatbot', 'wifiTrialReminderCard'];
    this.removeHiddenFeatures(selectedVehicleFeatures, hideFeatures);
  }

  /**
  * @function close closes the side nav when called
  **/
  public close(): void {
    this.sidenav.close();
  }

  /**
  * @function removeHiddenFeatures removes the hidden features from the selected vehicles features
  **/
  public removeHiddenFeatures(selectedVehicleFeatures: any, hideFeatures: string[]): void {
    this.showFeatures = Object.assign({}, selectedVehicleFeatures);
    for (const [key, value] of Object.entries(this.showFeatures)) {
      if (value === 0) {
        delete this.showFeatures[key];
      }
    }
    hideFeatures.forEach(element => {
      if (this.showFeatures.hasOwnProperty(element)) {
        delete this.showFeatures[element];
      }
    });
  }

  /**
  * @function getTranslatedFeature returns the string to translate
  **/
  public getTranslatedFeature(feature): string {
    if (this.selectedVehicle['vehicle']['region'] === 'CA' && feature === 'scheduleMaintenance') {
      return 'app-features.features.labels.call-dealer'
    }
    return 'app-features.features.labels.' + feature;
  }
}
